import styled from "styled-components";
import { colors } from "../common/element/elements.js";

export const Styles = styled.div`
  .admission-process {
    background: ${colors.bg2};
    padding: -20px 0 70px;

    .sec-title {
      margin-bottom: 45px;

      h4 {
       color: ${colors.black1};
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 1px;
        margin-bottom: 8px;
        text-align: center;
      }

      h3 {
        color: ${colors.black1};
        font-weight: 700;
        line-height: 42px;
        margin-bottom: 10px;

        @media (max-width: 575px) {
          font-size: 24px;
          line-height: 32px;
        }
      }

      p {
        color: ${colors.text2};
        font-size: 16px;
        margin-bottom: 0;
      }
    }

    .process-wrap {
      background: #fff;
      border-radius: 16px;
      padding: 35px 30px;

      @media (max-width: 575px) {
        padding: 25px 18px;
      }
    }

    .process-card {
      background: #ffffff;
      border: 1px solid #ececec;
      border-radius: 10px;
      padding: 26px 22px;
      height: 100%;
      text-align: center;
      box-shadow: 0 2px 6px rgba(24, 43, 73, 0.04);
      transition: all 0.3s ease;

      &:hover {
        border-color: ${colors.green};
        box-shadow: 0 8px 18px rgba(24, 43, 73, 0.08);
      }

      .step-number {
        width: 32px;
        height: 32px;
        line-height: 32px;
        border-radius: 50%;
        background: ${colors.green2};
        color: #ffffff;
        font-weight: 600;
        font-size: 15px;
        margin: 0 auto 14px;
        display: block;
      }

      h5 {
        color: ${colors.black1};
        font-weight: 600;
        font-size: 18px;
        margin-bottom: 8px;
      }

      p {
        color: ${colors.text2};
        font-size: 15px;
        margin-bottom: 0;
      }
    }

    .process-col {
      margin-bottom: 24px;
    }
  }
`;
